import React from "react";
import "./Breadcrumbs.scss";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
const breadcrumbsStructureData = (listOfItems) => {
    const schema = document.createElement("script");
    const items = listOfItems.filter(f=>f.url).map((element, index) => {
    	let itemsObj = {
			"@type": "ListItem",
			"position": index,
			"name": element.name
		};
		if (element.url !== "#") itemsObj["item"] = element.url;
        return itemsObj;
    });
    const schemaStructure = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": items
    };
    schema.type = "application/ld+json";
    schema.text = JSON.stringify([schemaStructure]);
    document.querySelector("head").appendChild(schema);
};

const Breadcrumbs = props => {
    const list = [
        {
            url: ConfigurationHelper.getGlobalConfiguration().public_base_url + ConfigurationHelper.getGlobalConfiguration().sub_folder+"/",
            name: "Home",
            active: props.isHomePage
        },
        ...props.breadcrumbsList
    ];
    const className = props.className ? props.className : "";

    if(props.renderStructureData)
        breadcrumbsStructureData(list);

    return (
        <div className={"container "+className}>
            <div className={"row"}>
                <div className="col-12 col-sm-12 col-md-12">
                    <ul className={"tvp-breadcrumbs "+(props.keepOnMobile ? "keep-on-mobile": "")}>
                        {list.map((item, index) => {

                            return (<li className={item.hideItemOnMobile ? "hide-item-mobile": ""}
                                        key={index}>
                                {item.active ?
                                    <span >
                                        <span className={(item.active ? "active" : "")} >{item.name}</span>
                                    </span> : item.url ?
                                        <a href={item.url}>
                                            <span className={item.highlightMobile ? "highlight" : ""}>{item.name}</span>
                                        </a>:
                                        <span >
                                        <span className={(item.active ? "active" : "")} >{item.name}</span>
                                    </span>
                                }
                            </li>)
                        })}
                    </ul>
                </div>
            </div>
        </div>

    );
};

Breadcrumbs.defaultProps = {
    breadcrumbsList: [],
    isHomePage: false,
    keepOnMobile: false,
    renderStructureData : true
};
export default Breadcrumbs;